
<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="false"
>
</app-st-banner>
<br><br><br><br><br>
<div class="container-xxl">
  <div class="row pt-4 pb5">
    <div class="col-2 d-flex justify-content-center neg-margin">
      <!--<app-st-profile-picture></app-st-profile-picture>-->
    </div>
    <div class="col-8">
      <!--<app-st-breadcrumbs [crumbs]="breadCrumbs"></app-st-breadcrumbs>-->
      <app-st-header-title [inputVal]="'Login'"></app-st-header-title>
      <div class="container st-form">
        <div *ngIf="showMessages" class="container st-form text-danger" #goUp>
          <app-st-span><b>Please validate the following: </b></app-st-span>
          <div *ngFor="let errorMsg of messages" class="alert alert-danger" role="alert">
            <b>{{errorMsg.field}}: </b> {{errorMsg.detail}}
          </div>
          <br>
        </div>
        <div>
          <app-st-input-text [idVal]="'username-text-id'" [label]="'Username'" [placeHolderVal]="'Email'"></app-st-input-text>
          <app-st-input-sensitive-text [idVal]="'password-text-id'" [idToggleTextVal]="'hide-toggle-button'"  [label]="'Password'" (keydown.enter)="this.onSignIn()"></app-st-input-sensitive-text>
        </div>
        <br>
        <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
          <app-st-button [idVal]="'sign-in-button-id'" [label]="'Sign In'" [primary]="true"
                                (click)="this.onSignIn()"></app-st-button>
          <app-st-button [idVal]="'sign-up-button-id'" [label]="'Sign Up'" [primary]="false"
                         (click)="this.onSignUp()"></app-st-button>
        </div>
        <br>
        <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
          <div><a href="/app/login/forgot-username"><u>Forgot Username?</u></a></div>
          <div><a href="/app/login/reset-password-request"><u>Forgot Password?</u></a></div>
        </div>
        <br>
        <br>
        <p class="webtext-black-large"><b>Are you a nonprofit consultant? Partner with us!</b></p>
        <p class="webtext-black-large">Help your clients identify donors, research funders, and build stronger fundraising strategies with Scalanthropy's powerful prospect research platform.</p>

        <p class="webtext-black-large">Consultant accounts are available by invitation from an active nonprofit client. Already have an invitation? Sign in below. Need access? Ask your nonprofit client to invite you.</p>


        <hr class="solid">
        <br>
        <div class="col2 d-grid gap-2 d-md-flex justify-content-md-center align-items-center">
          <app-st-button [idVal]="'get-approved-for-consultants-button-id'" [label]="'Get Approved for Consultants'" [primary]="true"
                         (click)="this.onGetApprovedForConsultants()"></app-st-button>
          <app-st-button [idVal]="'sign-up-for-approved-consultants-button-id'" [label]="'Referral Code? Sign Up Here!'" [primary]="false"
                         (click)="this.onSignUpForApprovedConsultants()"></app-st-button>
        </div>
      </div>

    </div>
  </div>
</div>
<script>
  $(document).ready(function() {
    $("#show_hide_password a").on('click', function(event) {
      event.preventDefault();
      if($('#show_hide_password input').attr("type") == "text"){
        $('#show_hide_password input').attr('type', 'password');
        $('#show_hide_password i').addClass( "fa-eye-slash" );
        $('#show_hide_password i').removeClass( "fa-eye" );
      }else if($('#show_hide_password input').attr("type") == "password"){
        $('#show_hide_password input').attr('type', 'text');
        $('#show_hide_password i').removeClass( "fa-eye-slash" );
        $('#show_hide_password i').addClass( "fa-eye" );
      }
    });
  });
</script>
